import React from 'react';
import { useTranslation } from 'react-i18next';
import InfoTooltip from '@/shared/components/forms/InfoTooltip';

interface HeaderCheckboxProps {
  hasHeader: boolean;
  onHeaderChange: (hasHeader: boolean) => void;
}

const HeaderCheckbox: React.FC<HeaderCheckboxProps> = ({
  hasHeader,
  onHeaderChange
}) => {
  const { t } = useTranslation('dataUpload');

  return (
    <div className="mb-3 sm:mb-4 flex items-center space-x-2 sm:space-x-3">
      <input
        type="checkbox"
        id="header-checkbox"
        className="checkbox-input w-4 h-4 sm:w-5 sm:h-5 flex-shrink-0"
        checked={hasHeader}
        onChange={(e) => onHeaderChange(e.target.checked)}
      />
      <label htmlFor="header-checkbox" className="checkbox-label text-xs sm:text-sm md:text-base">
        {t('headerOption.label')}
      </label>
      <InfoTooltip text={t('tooltips.headerOption')} />
    </div>
  );
};

export default HeaderCheckbox;